# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

#import "../fragments/todo-template-fragment.graphql"

query GetClosedLeadTaskTemplate($taskTemplateId: ID!) {
    closedLeadTaskTemplate(id: $taskTemplateId) {
        ...TodoTemplateCard
    }
}
